import styled from 'styled-components';
import { colorShade } from '../utils/style';

interface SeparatorProps {
    orientation?: SeparatorOrientation;
    color?: SeparatorColor;
    size?: SeparatorSize;
    offset?: `${number}${'px' | '%'}`;
    spacing?: number;
}

export enum SeparatorOrientation { HORIZONTAL, VERTICAL }
export enum SeparatorColor { PRIMARY, SECONDARY, SHADE }
export enum SeparatorSize { MEDIUM, LARGE }

export default function Separator({ orientation = SeparatorOrientation.HORIZONTAL, color = SeparatorColor.SHADE, size = SeparatorSize.MEDIUM, offset = '10px', spacing = 0 }: SeparatorProps) {
    return (
        <Wrapper className={`${orientation === SeparatorOrientation.HORIZONTAL ? 'horizontal' : 'vertical'} color-${color}`}>
            <div style={{ margin: orientation === SeparatorOrientation.HORIZONTAL ? `${spacing}px ${offset}` : `${offset} ${spacing}px` }} className={`separator color-${color} size-${size}`}></div>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    &.horizontal {
        flex-direction: row;
        .separator {
            height: 2px;
            &.size-1 { height: 3px; }
            border-radius: 2px;
            margin: 0 10px;
        }
    }

    &.vertical {
        flex-direction: column;
        .separator {
            width: 2px;
            &.size-1 { width: 3px; }
            border-radius: 2px;
            
            margin: 10px 0;
        }
    }

    .separator {
        flex-grow: 1;

        &.color-0 {background-color: ${props => colorShade(props.theme.primaryColor, 0.0)};}
        &.color-1 {background-color: ${props => props.theme.backgroundColor};}
        &.color-2 {background-color: #ffffff22;}
    }

`